module.exports = __webpack_public_path__ + "videos/Gritify_company_final_sv.0af7f1b.mp4";